import { render, staticRenderFns } from "./EWUserLimitConfigList.vue?vue&type=template&id=112fe714&"
import script from "./EWUserLimitConfigList.vue?vue&type=script&lang=js&"
export * from "./EWUserLimitConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports